import { COLORS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export const stylesheet = createStyleSheet({
  cardWrapper: {
    borderRadius: '8px',
    border: `1px solid ${COLORS.BLUE_GRAY.LIGHT}`,
    gap: '24px',
    padding: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  dateWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dateLabel: {
    minWidth: '32px',
  },
  dateInput: {
    minWidth: '400px',
  },
});

export default stylesheet;
